/**
 * 全站统一的接口信封格式。后端所有响应、前端 axios 拦截器都以此为准，
 * 任何接口都不要直接裸返数据。
 */
/** 统一错误码。新增错误码时同步在前端 i18n 里补对应文案。 */
export const API_ERROR_CODE = {
    VALIDATION_FAILED: 'VALIDATION_FAILED',
    UNAUTHORIZED: 'UNAUTHORIZED',
    TOKEN_EXPIRED: 'TOKEN_EXPIRED',
    FORBIDDEN: 'FORBIDDEN',
    NOT_FOUND: 'NOT_FOUND',
    CONFLICT: 'CONFLICT',
    /** 单据当前状态不允许该操作（如草稿才能提交审批） */
    INVALID_STATE: 'INVALID_STATE',
    RATE_LIMITED: 'RATE_LIMITED',
    SAP_ERROR: 'SAP_ERROR',
    /** 依赖的基础设施暂时不可用（数据库连不上等）—— 不是代码错误，重试即可 */
    SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE',
    /** 请求体或上传文件超过服务器允许的大小（body-parser / multer 限制） */
    PAYLOAD_TOO_LARGE: 'PAYLOAD_TOO_LARGE',
    INTERNAL_ERROR: 'INTERNAL_ERROR',
};
export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 20;
export const MAX_PAGE_SIZE = 200;
//# sourceMappingURL=api.js.map